import React from 'react'
import { CirclePicker, ColorResult, CompactPicker } from 'react-color'

import { Button } from 'src/chrome'
import { useState } from 'src/hooks'

import styles from './colorPicker.module.scss'
import { ColorFragment } from 'src/graphql'
import { rgbString } from 'src/redux/selectors/text'

interface ColorPickerProps {
  selectColor: (color: ColorFragment) => void
  selectedColor?: ColorFragment
  className?: string
  removeColor?: () => void
}

const ColorPicker: React.FC<ColorPickerProps> = props => {
  const [shouldShowMoreColors, setShouldShowMoreColors] = useState(false)
  const { className, selectColor, selectedColor, removeColor } = props

  const handleMoreColors = () => {
    setShouldShowMoreColors(c => !c)
  }

  const colors = [
    '#F44336',
    '#E91E63',
    '#9C27B0',
    '#673AB7',
    '#3F51B5',
    '#2196F3',
    '#03A9F4',
    '#00BCD4',
    '#009688',
    '#4CAF50',
    '#8BC34A',
    '#CDDC39',
    '#FFEB3B',
    '#FFC107',
    '#FF9800',
    '#FF5722',
    '#795548',
    '#607D8B',
    '#fff',
    '#000000',
  ]

  return (
    <div
      className={
        className ? `${styles.colorPicker} ${className}` : styles.colorPicker
      }
    >
      <div id={'color_picker'}>
        {shouldShowMoreColors ? (
          <CompactPicker
            color={selectedColor ? rgbString(selectedColor) : ''}
            onChangeComplete={(color: ColorResult) =>
              selectColor({
                red: color.rgb.r,
                green: color.rgb.g,
                blue: color.rgb.b,
              })
            }
          />
        ) : (
          <CirclePicker
            color={selectedColor ? rgbString(selectedColor) : ''}
            colors={colors}
            onChangeComplete={(color: ColorResult) =>
              selectColor({
                red: color.rgb.r,
                green: color.rgb.g,
                blue: color.rgb.b,
              })
            }
          />
        )}
      </div>
      <div className={styles.moreColors}>
        <Button
          title={shouldShowMoreColors ? 'less colors' : 'more colors'}
          onClick={handleMoreColors}
        />
      </div>
      {selectedColor && !className && (
        <div className={styles.removeColor} onClick={() => removeColor?.()}>
          Remove Color
        </div>
      )}
    </div>
  )
}

export default ColorPicker
